/* ===============================================================
   LLCL Motion Stage v5.0 / Native pinned cinematic scroll timeline
   Only WORK / self-contained. Avoid wheel / touch hijacking.
   - Natural page enters first still frame after Casa promo.
   - Hold first frame ~1 viewport, ease two vertical reveals,
     short second dwell, then last frame held before exit.
   - Sticky root stays pinned until all three have been shown.
   - Dots scroll to intentional stable scene positions.
   =============================================================== */
(function () {
  'use strict';
  var instances = new WeakMap();
  var W=window;
  var FIRST_HOLD=1.00;      // One full viewport of first scene
  var TRANSITION=1.00;      // One viewport per reveal
  var BETWEEN=0.25;         // Short stable pause on intermediate looks
  var LAST_HOLD=1.00;       // One full viewport on final look
  function clamp(n,min,max){return Math.min(max,Math.max(min,n));}
  function ease(n){n=clamp(n,0,1);return n*n*(3-2*n);}
  function timeline(count){
    var segments=[],start=FIRST_HOLD;
    for(var i=0;i<count-1;i++){
      segments.push({from:i,to:i+1,start:start,end:start+TRANSITION});
      start+=TRANSITION;
      if(i<count-2)start+=BETWEEN;
    }
    return {segments:segments,travel:start+LAST_HOLD,total:start+LAST_HOLD+1};
  }
  function locate(t,info,count){
    if(t<=FIRST_HOLD)return {from:0,to:0,f:0,active:0};
    for(var i=0;i<info.segments.length;i++){
      var s=info.segments[i];
      if(t<s.start)return {from:s.from,to:s.from,f:0,active:s.from};
      if(t<=s.end){
        var f=ease((t-s.start)/(s.end-s.start));
        return {from:s.from,to:s.to,f:f,active:f>=.5?s.to:s.from};
      }
    }
    return {from:count-1,to:count-1,f:0,active:count-1};
  }
  function mount(root){
    if(instances.has(root))return;
    var stage=root.querySelector('.ll-ms__viewport');
    var slides=Array.from(root.querySelectorAll('[data-ll-motion-scene]'));
    var buttons=Array.from(root.querySelectorAll('[data-ll-motion-step]'));
    var page=root.querySelector('[data-ll-motion-page]');
    var prev=root.querySelector('[data-ll-motion-prev]');
    var next=root.querySelector('[data-ll-motion-next]');
    if(!stage||!slides.length)return;
    var specs=timeline(slides.length);
    root.style.setProperty('--ll-ms-track-vh',String(specs.total));
    var reduce=W.matchMedia && W.matchMedia('(prefers-reduced-motion: reduce)');
    var raf=0,dead=false,active=0,lastActive=-1,lastTone='';
    var offs=[],lastProgress=-1;
    var promo=document.querySelector('[data-ll-casa]');
    function on(el,event,fn,opts){
      if(!el)return;
      el.addEventListener(event,fn,opts);
      offs.push(function(){el.removeEventListener(event,fn,opts);});
    }
    function stageMetrics(){
      var b=root.getBoundingClientRect();
      var viewport=stage.getBoundingClientRect();
      var docTop=W.scrollY+b.top;
      var stickyTop=parseFloat(W.getComputedStyle(stage).top)||0;
      var height=Math.max(1,viewport.height);
      var begin=docTop-stickyTop;
      return {begin:begin,height:height};
    }
    function progress(){
      var p=stageMetrics();
      return clamp((W.scrollY-p.begin)/p.height,0,specs.travel);
    }
    function jumpTo(i){
      if(dead)return;
      i=clamp(i,0,slides.length-1);
      var m=stageMetrics();
      var position;
      if(i===0)position=FIRST_HOLD*.45;
      else if(i===slides.length-1)position=specs.travel-LAST_HOLD*.55;
      else{
        var transition=specs.segments[i-1];
        position=transition.end+BETWEEN*.45;
      }
      W.scrollTo({top:Math.max(0,m.begin+position*m.height),behavior:reduce&&reduce.matches?'auto':'smooth'});
    }
    function nav(i,tone){
      if(i!==lastActive){
        lastActive=i;active=i;
        if(page)page.textContent=String(i+1).padStart(2,'0');
        buttons.forEach(function(b,k){
          var yes=k===i;
          b.classList.toggle('is-active',yes);
          b.setAttribute('aria-current',yes?'true':'false');
        });
      }
      if(tone!==lastTone){
        lastTone=tone;
        root.dataset.tone=tone;
      }
      root.dataset.scene=String(i+1);
    }
    function draw(){
      raf=0;
      if(dead||!root.isConnected)return;
      var t=progress();
      var st=locate(t,specs,slides.length);
      if(reduce&&reduce.matches){
        st={from:st.active,to:st.active,f:0,active:st.active};
      }
      var inTransition=st.from!==st.to;
      var toneIndex=inTransition&&st.f>=.5?st.to:st.from;
      var tone=slides[toneIndex].dataset.tone||'white';
      nav(st.active,tone);
      slides.forEach(function(slide,i){
        var from=i===st.from,to=inTransition&&i===st.to;
        var visible=from||to;
        slide.classList.toggle('is-current',i===st.active);
        slide.classList.toggle('is-motion-visible',visible);
        slide.classList.toggle('is-motion-front',to);
        slide.setAttribute('aria-hidden',i===st.active?'false':'true');
        slide.inert=i!==st.active;
        if(!visible){
          slide.style.visibility='hidden';
          slide.style.opacity='0';
          slide.style.transform='';
          var oldimg=slide.querySelector('.ll-ms__img');
          var oldgrid=slide.querySelector('.ll-ms__scene-grid');
          if(oldimg)oldimg.style.transform='';
          if(oldgrid){oldgrid.style.opacity='';oldgrid.style.transform='';}
          return;
        }
        var y=0,parallax=0,alpha=1,dy=0;
        if(inTransition&&to){
          y=(1-st.f)*100;
          parallax=-(1-st.f)*5;
          alpha=clamp((st.f-.12)/.65,0,1);
          dy=(1-st.f)*18;
        }else if(inTransition&&from){
          y=-st.f*100;
          parallax=st.f*5;
          alpha=clamp((.72-st.f)/.62,0,1);
          dy=-st.f*14;
        }
        slide.style.visibility='visible';
        slide.style.opacity='1';
        slide.style.transform='translate3d(0,'+y.toFixed(3)+'%,0)';
        var img=slide.querySelector('.ll-ms__img');
        if(img)img.style.transform=reduce&&reduce.matches?'none':'scale(1.08) translate3d(0,'+parallax.toFixed(3)+'%,0)';
        var grid=slide.querySelector('.ll-ms__scene-grid');
        if(grid){grid.style.opacity=alpha.toFixed(3);grid.style.transform='translate3d(0,'+dy.toFixed(2)+'px,0)';}
      });
      lastProgress=t;
    }
    function tick(){if(!raf)raf=W.requestAnimationFrame(draw);}
    buttons.forEach(function(b){
      on(b,'click',function(){jumpTo(Number(b.getAttribute('data-ll-motion-step')));});
    });
    on(prev,'click',function(){jumpTo(active-1);});
    on(next,'click',function(){jumpTo(active+1);});
    on(stage,'keydown',function(ev){
      if(ev.target!==stage)return;
      var dir=ev.key==='ArrowDown'||ev.key==='PageDown'||ev.key==='ArrowRight'?1:
        (ev.key==='ArrowUp'||ev.key==='PageUp'||ev.key==='ArrowLeft'?-1:0);
      if(!dir)return;
      if(dir>0&&active>=slides.length-1)return;
      if(dir<0&&active<=0)return;
      ev.preventDefault();
      jumpTo(active+dir);
    });
    on(W,'scroll',tick,{passive:true});
    on(W,'resize',tick,{passive:true});
    // Casa changes natural document height; use fresh geometry on each
    // frame without hard-coded offsets or interfering with its animation.
    on(document,'ll:promo-state',tick);
    on(document,'shopify:block:select',function(ev){
      var scene=ev.target.closest('[data-ll-motion-scene]');
      if(scene&&root.contains(scene))jumpTo(slides.indexOf(scene));
    });
    on(document,'shopify:section:unload',function(ev){
      if(!ev.target.contains(root))return;
      dead=true;
      if(raf)W.cancelAnimationFrame(raf);
      offs.forEach(function(off){off();});
      instances.delete(root);
    });
    if('ResizeObserver' in W){
      var obs=new ResizeObserver(tick);
      obs.observe(stage);
      if(promo)obs.observe(promo);
      offs.push(function(){obs.disconnect();});
    }
    instances.set(root,true);
    tick();
  }
  function boot(ctx){(ctx||document).querySelectorAll('[data-ll-motion-stage]').forEach(mount);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){boot(document);});
  else boot(document);
  document.addEventListener('shopify:section:load',function(ev){boot(ev.target);});
})();